




































import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { registration, ParamsInfo } from '@/api/property/registration'
import { upload } from '@/api/property/upload'
import { CommonDataModule } from '@/store/modules/commonData'
import { transformMinute, formatStampTime, formatStampToDateString, formatStampNoDate} from '@/utils/translateTime'

@Component({
  components: {
    Pagination
  }
})
export default class CleanDetails extends Vue {
  private total: number = 0
  private paramsInfo: ParamsInfo = {
    startTime: '',
    endTime: '',
    searchCriteria: '',
    pageNum: 1,
    pageSize: 10,
    wyOrganizationId: this.$Cookies.get('wyOrganizationId')
  }
  private reportList: any[] = []
  private orgInfo: any[] = []
  private showStartTime: any = ''
  private showEndTime: any = ''

  private async created() {
    await this.fetchData()
    this.orgInfo = await CommonDataModule.getOrganizations('property')
  }

  private async fetchData() {
    const res: any = await registration('GET', this.paramsInfo, null, '/Page')
    console.log(res)
    this.reportList = res
    console.log(this.reportList)
    await this.queryTotal()
  }
  private async queryTotal() {
    let queryData = Object.assign({}, this.paramsInfo)
    delete queryData.pageSize
    delete queryData.pageNum
    const res: any = await registration('GET', queryData, null, '/Count')
    this.total = res
  }
  private handleSearch() {
    if (this.paramsInfo.endTime && this.paramsInfo.startTime && this.paramsInfo.startTime > this.paramsInfo.endTime) {
      this.$message.warning('结束时间必须大于开始时间')
      return
    }
    this.paramsInfo.startTime = this.showStartTime ? this.showStartTime.toString().substr(0, 10) : null
    this.paramsInfo.endTime = this.showEndTime ? this.showEndTime.toString().substr(0, 10) : null
    this.fetchData()
  }
  private async exportExcel() {
    let exportData = Object.assign({}, this.paramsInfo)
    if (exportData.endTime && exportData.startTime && exportData.startTime > exportData.endTime) {
      this.$message.warning('结束时间必须大于开始时间')
      return
    }
    exportData.startTime = exportData.startTime ? exportData.startTime.toString().substr(0, 10) : null
    exportData.endTime = exportData.endTime ? exportData.endTime.toString().substr(0, 10) : null
    const res: any = await upload('GET', exportData, null, '/RegistrationExcel')
    window.location.href = res
  }

  // 时间戳转换成日期:
  private formatStampTime(stampTime: number) {
    if (stampTime != null) {
      return formatStampTime(stampTime)
    } else {
      return '--'
    }
  }

  private formatStampNoDate(stampTime: number) {
    if (stampTime != null) {
      return formatStampNoDate(stampTime)
    } else {
      return '--'
    }
  }

  private formatStampToDateString(stampTime: number) {
    if (stampTime != null) {
      return formatStampToDateString(stampTime)
    } else {
      return '--'
    }
  }

  private transLateTime(minutes: any) {
    if (minutes != null) {
      return transformMinute(minutes)
    } else {
      return '--'
    }
  }

}
